// Initialize the form
import * as tool from './_tools';

function initializeForm() {
    let currentGreatStep = 0;
    let currentSmallStep = 0;

    const greatSteps = document.querySelectorAll('.greatStep');
    const stepIndicatorNumbers = document.querySelectorAll('.step-indicator .number');
    const stepIndicatorLines = document.querySelectorAll('.step-indicator .line');
    const previousButton = document.querySelectorAll('.previousStep');
    const nextButton = document.querySelector('.nextGreatStep');
    const submitButton = document.querySelector('.aici-submit');
    const btnHolder = document.querySelector('.btn-holder');
    const checkedSVG = '<svg width="18px" height="18px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"\n' +
        '>\n' +
        '    <g id="🔍-Product-Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n' +
        '        <g id="ic_fluent_checkbox_checked_24_regular" fill="#e31322" fill-rule="nonzero">\n' +
        '            <path d="M18.25,3 C19.7687831,3 21,4.23121694 21,5.75 L21,18.25 C21,19.7687831 19.7687831,21 18.25,21 L5.75,21 C4.23121694,21 3,19.7687831 3,18.25 L3,5.75 C3,4.23121694 4.23121694,3 5.75,3 L18.25,3 Z M18.25,4.5 L5.75,4.5 C5.05964406,4.5 4.5,5.05964406 4.5,5.75 L4.5,18.25 C4.5,18.9403559 5.05964406,19.5 5.75,19.5 L18.25,19.5 C18.9403559,19.5 19.5,18.9403559 19.5,18.25 L19.5,5.75 C19.5,5.05964406 18.9403559,4.5 18.25,4.5 Z M10,14.4393398 L16.4696699,7.96966991 C16.7625631,7.6767767 17.2374369,7.6767767 17.5303301,7.96966991 C17.7965966,8.23593648 17.8208027,8.65260016 17.6029482,8.94621165 L17.5303301,9.03033009 L10.5303301,16.0303301 C10.2640635,16.2965966 9.84739984,16.3208027 9.55378835,16.1029482 L9.46966991,16.0303301 L6.46966991,13.0303301 C6.1767767,12.7374369 6.1767767,12.2625631 6.46966991,11.9696699 C6.73593648,11.7034034 7.15260016,11.6791973 7.44621165,11.8970518 L7.53033009,11.9696699 L10,14.4393398 L16.4696699,7.96966991 L10,14.4393398 Z"\n' +
        '                  id="🎨Color">\n' +
        '\n' +
        '            </path>\n' +
        '        </g>\n' +
        '    </g>\n' +
        '</svg>';
    const unCheckedSVG = '<svg width="18px" height="18px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"\n' +
        '>\n' +
        '    <g id="🔍-Product-Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n' +
        '        <g id="ic_fluent_checkbox_unchecked_24_regular" fill="#8f8f8f" fill-rule="nonzero">\n' +
        '            <path d="M5.75,3 L18.25,3 C19.7687831,3 21,4.23121694 21,5.75 L21,18.25 C21,19.7687831 19.7687831,21 18.25,21 L5.75,21 C4.23121694,21 3,19.7687831 3,18.25 L3,5.75 C3,4.23121694 4.23121694,3 5.75,3 Z M5.75,4.5 C5.05964406,4.5 4.5,5.05964406 4.5,5.75 L4.5,18.25 C4.5,18.9403559 5.05964406,19.5 5.75,19.5 L18.25,19.5 C18.9403559,19.5 19.5,18.9403559 19.5,18.25 L19.5,5.75 C19.5,5.05964406 18.9403559,4.5 18.25,4.5 L5.75,4.5 Z"\n' +
        '                  id="🎨Color">\n' +
        '\n' +
        '            </path>\n' +
        '        </g>\n' +
        '    </g>\n' +
        '</svg>';
    const mainContainer = document.querySelector('.aici-container');


    const resetForm = () => {
        const inputs = document.querySelectorAll('input[type="radio"], input[type="checkbox"]');
        inputs.forEach((input) => {
            input.checked = false;
            input.closest('label').classList.remove('selected');
        });
    }


    // Function to update the visibility of great steps
    const updateGreatSteps = () => {
        greatSteps.forEach((step, index) => {
            let timeout = 500;
            let opacity = 0;
            let transform = 'translateX(100%)';
            step.style.opacity = opacity; //hide all the great steps
            //slide the current great step to the left
            if (index === currentGreatStep) {
                timeout = 500;
                opacity = 1
                transform = 'translateX(0)';
            }
            if (index === currentGreatStep + 1) {
                transform = 'translateX(100%)';
            }
            if (index === currentGreatStep - 1) {
                transform = 'translateX(-100%)';
            }
            hideGreatSteps(step, index, transform, timeout, opacity);
        });
    };

    const hideGreatSteps = (step, index, transform, timeout = 300, opacity = 0) => {

        step.style.opacity = opacity;
        step.style.transform = transform;
        setTimeout(() => {
            step.classList.toggle('hide', index !== currentGreatStep);
            void step.offsetHeight; // Force reflow
            void document.querySelector(".aici-container").offsetHeight; // Force reflow

        }, timeout);

    }

    // Function to update the step indicator
    const updateStepIndicator = () => {
        stepIndicatorNumbers.forEach((number, index) => {
            number.classList.toggle('disabled', index > currentGreatStep);
        });
    };

    // Function to update smaller steps within a great step
    const updateSmallSteps = () => {
        const currentGreatStepElement = greatSteps[currentGreatStep];
        const smallSteps = currentGreatStepElement.querySelectorAll('.step');
        if (currentSmallStep === 0 && smallSteps.length > 1) {
            previousButton.forEach((button) => {
                hideButton(button);
            });
        } else {
            previousButton.forEach((button) => {
                showButton(button);
            });
        }

        smallSteps.forEach((step, index) => {
            if (index > currentSmallStep) {
                // Hide future steps with a slide-down effect
                step.style.zIndex = -1;
                step.style.transform = 'translateY(-100px)'; // Slide down
                setTimeout(() => {
                    step.classList.add('hide'); // Add .hide after transition
                    step.classList.remove('hidden'); // Ensure they are visible
                    void step.offsetHeight; // Force reflow
                }, 300); // Match the CSS transition duration
            } else if (index < currentSmallStep) {
                // Disable previous steps
                step.style.zIndex = 1;
                step.classList.remove('hide'); // Ensure they are not hidden
                step.classList.remove('hidden'); // Ensure they are visible
                step.classList.add('disabled');
                step.style.transform = 'translateY(0)'; // Reset transform
                void step.offsetHeight; // Force reflow
            } else {
                // Current step
                step.classList.remove('hide'); // Remove .hide first
                void step.offsetHeight; // Force reflow
                setTimeout(() => {
                    step.style.transform = 'translateY(0)'; // Reset transform
                    step.classList.remove('hidden'); // Remove .hidden for transition
                }, 0);
                step.classList.remove('disabled');
            }
        });
    };

    // Function to move to the next great step
    const goToNextGreatStep = () => {

        if (currentGreatStep < greatSteps.length - 1) {
            //animate the change of great step
            updateLoadingLine(4, 4); //force la ligne de chargement à 100% pour l'étape précédente
            currentGreatStep++;
            currentSmallStep = 0; // Reset small step when moving to the next great step
            updateGreatSteps();
            updateStepIndicator();
            updateSmallSteps();
            addInputListeners();
        }

    };

    // Function to move to the previous great step
    const goToPreviousGreatStep = () => {
        if (currentGreatStep > 0) {
            currentGreatStep--;
            const previousGreatStepElement = greatSteps[currentGreatStep];
            const previousSmallSteps = previousGreatStepElement.querySelectorAll('.step');
            currentSmallStep = previousSmallSteps.length - 1; // Set to the last small step of the previous great step
            updateLoadingLine(currentSmallStep, previousSmallSteps.length);
            updateGreatSteps();
            updateStepIndicator();
            updateSmallSteps();
            addInputListeners();
            previousButton.forEach((button) => {
                showButton(button);
            });
        }
        if (currentGreatStep !== greatSteps.length - 1) {
            hideButton(submitButton);
            showButton(nextButton);
            previousButton.forEach((button) => {
                showButton(button);
            });
            document.querySelector('#last-submit').classList.add('hide');
        }

    };

    // Function to move to the next small step
    const goToNextSmallStep = () => {
        const currentGreatStepElement = greatSteps[currentGreatStep];
        const smallSteps = currentGreatStepElement.querySelectorAll('.step');
        if (currentSmallStep < smallSteps.length - 1) {
            disableLabelsAndInputs(); //disable before updating the next step
            currentSmallStep++;
            updateLoadingLine(currentSmallStep, smallSteps.length);
            updateSmallSteps();
        }
    };

    // Function to move to the previous small step
    const goToPreviousSmallStep = () => {
        const currentGreatStepElement = greatSteps[currentGreatStep];
        const smallSteps = currentGreatStepElement.querySelectorAll('.step');

        if (currentSmallStep !== 0) {
            previousButton.forEach((button) => {
                showButton(button);
            });
            //unclick the input before and after updating the previous step
            unckeckInputs();
            currentSmallStep--;
            updateLoadingLine(currentSmallStep, smallSteps.length);
            unckeckInputs();

            //show the next button
            if (nextButton && currentSmallStep === smallSteps.length - 1) {
                showButton(nextButton);
            } else {
                hideButton(nextButton);
            }
            updateSmallSteps();
            enableLabelsAndInputs(); //enable after updating the previous step
        } else {
            goToPreviousGreatStep(); // Move to the previous great step if this is the first small step
            focusOnGreatStepTop();
            previousButton.forEach((button) => {
                showButton(button);
            });
        }

    };

    const unckeckInputs = () => {
        const currentGreatStepElement = greatSteps[currentGreatStep];
        const currentSmallStepElement = currentGreatStepElement.querySelectorAll('.step')[currentSmallStep];
        const inputs = currentSmallStepElement.querySelectorAll('input[type="radio"], input[type="checkbox"]');
        const checkboxes = currentGreatStepElement.querySelectorAll('input[type="checkbox"]');
        inputs.forEach((input) => {
            input.checked = false;
            input.closest('label').classList.remove('selected');
        });
        resetCheckedState(checkboxes);
    }

    const resetCheckedState = (checkboxes) => {
        checkboxes.forEach((checkbox) => {
            let svg = checkbox.closest('label').querySelector('.checkbox-svg');
            checkbox.checked = false;
            checkbox.closest('label').classList.remove('selected');
            if (svg) {
                svg.innerHTML = unCheckedSVG;
            }
        });
    }

    const disableLabelsAndInputs = () => {
        // Get the current small step element
        const currentGreatStepElement = greatSteps[currentGreatStep];
        const currentSmallStepElement = currentGreatStepElement.querySelectorAll('.step')[currentSmallStep];

        // Get all labels and inputs within the current small step
        const labels = currentSmallStepElement.querySelectorAll('label');
        const inputs = currentSmallStepElement.querySelectorAll('input[type="radio"], input[type="checkbox"]');

        // Disable or enable labels and inputs
        labels.forEach((label) => {
            label.classList.toggle('disabled'); // Add 'disabled' class to labels
        });

        inputs.forEach((input) => {
            input.disabled = true; // Disable the input element
            input.classList.toggle('disabled'); // Add 'disabled' class to inputs
        });
    };

    const enableLabelsAndInputs = () => {
        const currentGreatStepElement = greatSteps[currentGreatStep];
        const currentSmallStepElement = currentGreatStepElement.querySelectorAll('.step')[currentSmallStep];

        const labels = currentSmallStepElement.querySelectorAll('label');
        const inputs = currentSmallStepElement.querySelectorAll('input[type="radio"], input[type="checkbox"]');

        labels.forEach((label) => {
            label.classList.toggle('disabled', false); // Remove 'disabled' class from labels
        });

        inputs.forEach((input) => {
            input.disabled = false; // Enable the input element
            input.classList.toggle('disabled', false); // Remove 'disabled' class from inputs
        });
    };
    // Add event listener to back button
    previousButton.forEach((button) => {
        button.addEventListener('click', goToPreviousSmallStep);
    });
    // Add event listeners to inputs to enable the next step
    const addInputListeners = () => {
        if (document.querySelectorAll('label .checkbox-svg').length !== 0) {
            document.querySelectorAll('label .checkbox-svg').forEach((svg) => {
                svg.remove();
            });
        }

        const currentGreatStepElement = greatSteps[currentGreatStep];
        tool.waitForElem('input[type="radio"], input[type="checkbox"]').then(() => {


            const inputs = currentGreatStepElement.querySelectorAll('input[type="radio"], input[type="checkbox"]');
            let totalSmallSteps = currentGreatStepElement.querySelectorAll('.step').length;

            if (nextButton) {
                hideButton(nextButton);
            }

            // Add change event listeners to inputs
            inputs.forEach((input) => {
                input.addEventListener('change', (e) => {
                        updateLoadingLine(currentSmallStep, totalSmallSteps);
                        let currentSmallStepElement = currentGreatStepElement.querySelectorAll('.step')[currentSmallStep];// Toggle the 'selected' class on the closest label
                        input.closest('label').classList.toggle('selected', input.checked);
                        // Handle radio button logic
                        if (input.type === 'radio' && input.checked) {
                            // Get other radio buttons in the same group (same name)
                            const otherInputs = Array.from(currentSmallStepElement.querySelectorAll(
                                `input[type="radio"][name="${input.name}"]`
                            )).filter((i) => i !== input);
                            // Uncheck others in the group
                            otherInputs.forEach((i) => {
                                i.checked = false;
                                i.closest('label').classList.remove('selected');
                            });
                        }
                        //move to the next step if one input is checked, and it's a radio button else show the next button
                        if (currentGreatStepElement.querySelectorAll('.step').length === 1) {
                            if (nextButton) {
                                showButton(nextButton);
                            }
                        } else if ((currentGreatStepElement.querySelectorAll('.step').length > 1) && (input.checked && input.type === 'radio')) {
                            goToNextSmallStep();
                        }
                    }
                );
            });
            if (currentGreatStep === greatSteps.length - 1) {
                document.querySelector('.btn-holder').classList.add('hide');
                document.querySelector('#last-submit').classList.remove('hide');
            } else {
                document.querySelector('.btn-holder').classList.remove('hide');
                document.querySelector('#last-submit').classList.add('hide');
            }
            if (nextButton) {
                checkboxHandler(currentGreatStepElement);

            }
        }).catch((error) => {
            console.error('Error waiting for elements:', error);
        });
    }

    const updateLoadingLine = (currentSmallStep, smallSteps) => {
        if (!currentSmallStep) {
            currentSmallStep = 1;
        }
        const loadingLine = document.querySelectorAll('.line-loader');
        loadingLine.forEach((line, index) => {
            line.classList.toggle('active', index <= currentGreatStep);
        });
        if (currentSmallStep === 0) {
            currentSmallStep = 1;
        }
        let math = (currentSmallStep) / smallSteps * 100;
        if (currentSmallStep === 1 && smallSteps === 1) {
            math = 75;
        }
        if (isNaN(math)) {
            math = 0;
        }
        if (loadingLine[currentGreatStep]) {
            loadingLine[currentGreatStep].style.width = math + '%';
        }
    }

    const checkboxHandler = (currentGreatStepElement) => {
        let checkbox = currentGreatStepElement.querySelectorAll('input[type="checkbox"]');
        let checked = false;

        checkbox.forEach((input) => {
            const isAucun = ['aucun', 'aucune'].includes(input.value.toLowerCase());

            // Only create SVG for non-aucun/aucune checkboxes
            if (!isAucun) {
                let checkboxSvg = document.createElement('span');
                checkboxSvg.classList.add('checkbox-svg');
                checkboxSvg.style.position = 'absolute';
                checkboxSvg.style.backgroundColor = 'white';
                checkboxSvg.style.left = '-5px';
                checkboxSvg.style.top = '-5px';
                checkboxSvg.innerHTML = input.checked ? checkedSVG : unCheckedSVG;

                input.closest('label').prepend(checkboxSvg);
            }

            input.addEventListener('change', () => {
                const isAucun = ['aucun', 'aucune'].includes(input.value.toLowerCase());
                const otherCheckboxes = Array.from(checkbox).filter(cb => cb !== input);

                if (isAucun && input.checked) {
                    // Handle "aucun/aucune" selection
                    otherCheckboxes.forEach(cb => {
                        cb.checked = false;
                        cb.disabled = true;
                        cb.closest('label').classList.remove('selected');
                        // Reset non-aucun checkboxes to empty state
                        const svg = cb.closest('label').querySelector('.checkbox-svg');
                        if (svg) {
                            svg.innerHTML = unCheckedSVG;
                        }
                    });
                } else if (isAucun && !input.checked) {
                    // Re-enable other checkboxes when "aucun" is unchecked
                    otherCheckboxes.forEach(cb => cb.disabled = false);
                } else {
                    // Handle normal checkbox selection
                    if (input.checked) {
                        // Uncheck any "aucun/aucune" checkboxes
                        checkbox.forEach(cb => {
                            if (['aucun', 'aucune'].includes(cb.value.toLowerCase())) {
                                cb.checked = false;
                                cb.closest('label').classList.remove('selected');
                                const svg = cb.closest('label').querySelector('.checkbox-svg');
                                if (svg) svg.innerHTML = '<svg...></svg>'; // Empty SVG
                            }
                        });
                        // Re-enable all checkboxes
                        checkbox.forEach(cb => cb.disabled = false);
                        //add the checked svg to the label
                        const svg = input.closest('label').querySelector('.checkbox-svg');
                        if (svg) {
                            svg.innerHTML = checkedSVG;
                        }

                    } else {
                        //remove the checked svg from the label
                        const svg = input.closest('label').querySelector('.checkbox-svg');
                        if (svg) {
                            svg.innerHTML = unCheckedSVG;
                        }
                    }
                }
                // Update next button state
                checked = Array.from(checkbox).some(i => i.checked);
                if (checked) {
                    showButton(nextButton);
                } else {
                    hideButton(nextButton);
                }
            });
        });
    }

    const sendDataLayerCheckbox = () => {
        const currentGreatStepElement = greatSteps[currentGreatStep - 1];
        let checkboxes = currentGreatStepElement.querySelectorAll('input[type="checkbox"]:checked');
        let values = Array.from(checkboxes).map(checkbox => checkbox.value);
        let name = checkboxes[0].name;

        if (name == "tel-mail") {
            dataLayer.push({
                event: 'simulateur_outils',
                option: values.join(", "), // ou autres options selon le choix d’utilisateur
            });
        } else if (name == "charge-financiere") {
            dataLayer.push({
                event: 'simulateur_financement',
                option: values.join(", "), // ou autres options selon le choix d’utilisateur
            });
        }
    };

    const hideButton = (button) => {
        if (button) {
            if (button.classList.contains('hide')) return;
            button.classList.add('hidden');
            setTimeout(() => {
                button.classList.add('hide');
            }, 300);
            button.disabled = true;
        }
    };

    const showButton = (button) => {
        if (button) {
            if (!button.classList.contains('hide')) return;
            button.classList.add('hidden');
            button.classList.remove('hide');
            setTimeout(() => {
                button.classList.remove('hidden');
            }, 300);
            button.disabled = false;
        }
    }


// Add click event listener to the next button
// Add event listener to submit button
    if (nextButton) {
        tool.throttle(nextButton.addEventListener('click', () => {
            if (nextButton.classList.contains('disabled')) return;
            goToNextGreatStep();
            focusOnGreatStepTop();
            sendDataLayerCheckbox();
        }), 500);
    }


    const focusOnGreatStepTop = () => {
        tool.waitForElem('.step-indicator').then((step) => {
            step.scrollIntoView({behavior: 'smooth', block: 'start'});
        });
    }

// Initialize the form
    tool.waitForElem('.greatStep').then(() => {
        updateGreatSteps();
        updateStepIndicator();
        updateSmallSteps();
        addInputListeners();
        resetForm();
    }).catch((error) => {
        console.error('Error waiting for elements:', error);
    });
}

// Run the initialization
export {initializeForm};